export const ActionTypes = {
  LOADING: "GET_OPTION_DETAIL_LOADING",
  ERROR: "GET_OPTION_DETAIL_ERROR",
  SUCCESS: "GET_OPTION_DETAIL_SUCCESS",
};
